// extracted by mini-css-extract-plugin
export default {"container":"container_Y+4cs","img":"img_EDaqK","rightBlock":"rightBlock_eamNn","buttomText":"buttomText_TgVX+","buttomBlock":"buttomBlock_+4v4j"};